import { render, staticRenderFns } from "./manual-upgrade.vue?vue&type=template&id=77343b66&"
import script from "./manual-upgrade.vue?vue&type=script&lang=js&"
export * from "./manual-upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports